/* eslint-disable react/destructuring-assignment */
import { Tab } from '@mui/material';
import { styled } from '@mui/material/styles';

interface StyledTabProps {
  label: string;
}

const TabStyles = styled((props: StyledTabProps) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    textTransform: 'none',
    marginRight: '20px',
    minHeight: 'auto !important',
    padding: 0,
    paddingBottom: 8,
    paddingTop: 8,
    fontSize: '0.875rem',
    fontWeight: 600,
    '& p': {
      color: theme.palette.text.secondary,
    },
    '&:hover p': {
      color: theme.palette.text.secondary,
    },
    '&.Mui-selected p': {
      color: theme.palette.primary.main,
    },
    '&.Mui-selected:hover p': {
      color: theme.palette.primary.main,
    },
  }),
);

const CustomTab = (props:any) => (
  <TabStyles
    {...props}
  />
);

export default CustomTab;
